// components/Home.js
import React, { useEffect, useState } from 'react';
import { Box, Button, Grid2 } from '@mui/material';
import toast from 'react-hot-toast';
import { API_URL } from '../../../config';
import { LayoutDashboard } from '../../../layouts/DasboardLayout';
import TypographyTitle from '../../../components/Titles/TypographyTitle';
import DialogCrearEspecialidad from '../../../sections/Admin/Especialidades/DialogCrear';
import UsuariosTabla from '../../../sections/Admin/Usuarios/UsuariosTabla';
import DialogCrearUsuario from '../../../sections/Admin/Usuarios/DialogCrear';

const Page = () => {
  const [usuarios, setUsuarios] = useState([]);
  const [especialidades, setEspecialidades] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);

  const handleOpenDialog = () => {
    setOpenDialog(true);
  }

  const handleCloseDialog = () => {
    setOpenDialog(false);
  }

  const handleCrear = async (data) => {
    try {
      const response = await fetch(`${API_URL}/usuario`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
        },
        body: JSON.stringify(data),
      });
      const responseData = await response.json();
      if (response.ok) {
        toast.success('Usuario creado correctamente');
        handleCloseDialog();
        getEspecialidades();

        //Recargar la página
        setTimeout(() => {
          window.location.reload();
        }
          , 1000);
      }
      else {
        toast.error(responseData.message);
      }
    }
    catch (error) {
      toast.error('Error al crear la especialidad');
      console.error(error);
    }
  }

  const getUsuarios = async () => {
    try {
      const response = await fetch(`${API_URL}/usuario`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
        },
      });
      const data = await response.json();
      setUsuarios(data);
    }
    catch (error) {
      toast.error('Error al obtener los usuarios');
      console.error(error);
    }
  }

  const getEspecialidades = async () => {
    try {
      const response = await fetch(`${API_URL}/especialidad`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
        },
      });
      const data = await response.json();
      setEspecialidades(data);
    }
    catch (error) {
      toast.error('Error al obtener las especialidades');
      console.error(error);
    }
  }

  useEffect(() => {
    getUsuarios();
    getEspecialidades();
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'left',
        height: '100%',
        width: '100%',
        padding: '2rem',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'left',
          borderRadius: 5,
          padding: 2,
          marginBottom: '1rem',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
            marginBottom: 2,
          }}
        >
          <TypographyTitle variant='h4' marginBottom='1rem'>
            Usuarios
          </TypographyTitle>
          <Button
            variant='contained'
            color='primary'
            onClick={handleOpenDialog}
          >
            Agregar usuario
          </Button>
        </Box>
        <Grid2
          container
          spacing={2}
        >
          <UsuariosTabla usuarios={usuarios} especialidades={especialidades} />
        </Grid2>
      </Box>
      <DialogCrearUsuario
        open={openDialog}
        handleClose={handleCloseDialog}
        handleCrear={handleCrear}
        especialidades={especialidades}
      />
    </Box>
  );
};

const Usuarios = () => {
  return (
    <LayoutDashboard>
      <Page />
    </LayoutDashboard>
  );
}

export default Usuarios;
